import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  const year = new Date().getFullYear();
  const isAbby = window.origin.includes("abby");
  const name = `Truck & Trailer Repair ${isAbby ? "(Abby) ":""}Ltd.`
  return (
    <CFooter className="px-4">
      <div>
        <a href="http://speedtruckrepair.com/" target="_blank" rel="noopener noreferrer">
          Speed
        </a>
        <span className="ms-1">{name} &copy; {year} </span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Developed by</span>
        <a href="https://github.com/kaushikabhi999" target="_blank" rel="noopener noreferrer">
          Amit Kaushik &amp; Kavita Sharma
        </a>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
